import { render, staticRenderFns } from "./ProjectsArea.vue?vue&type=template&id=3b0b536e&scoped=true&lang=pug&"
import script from "./ProjectsArea.vue?vue&type=script&lang=js&"
export * from "./ProjectsArea.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsArea.vue?vue&type=style&index=0&id=3b0b536e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b536e",
  null
  
)

export default component.exports